import List from "./List";
import Update from "./Update";

export const Permissions = {
  read: "read:FormResponse",
  list: "list:FormResponse",
  update: "update:FormResponse",
  delete: "delete:FormResponse",
};

export const FormCancel = {
  List: List,
  Update: Update,
  Permissions,
};
